import React, {useEffect} from "react"

import Card from "@irati/ui/src/Layout/Card"
import {GROUP_CELEBRATION, RECOGNITION} from "@irati/recognition/constants/feedTypes"
import {REWARD} from "@irati/recognition/constants/recognitionViewTypes"

import {accountRecognitionsQuery} from "@irati/recognition/apollo/query/AccountRecognitions"
import {DisablePointerEventsOnScroll} from "@irati/ui/src/DisablePointerEventsOnScroll"
import tracking from "@irati-tracking/recognition/navigation"
import {NestedRoute} from "@irati/utils/history/routing"
import {match as Match} from "react-router-dom"
import {feedRecognitionQuery} from "@irati/recognition/apollo/query/FeedRecognition"
import {Query} from "@irati/utils/services/apollo"
import {groupCelebrationQuery} from "@irati/recognition/apollo/query/GroupCelebration"
import ErrorPopup from "../../../components/Popup/Error"
import RecognitionPopup from "../../../components/Popup/Recognition"
import {RawRecognitionRoutes} from "../../../enums/Routes"
import GroupCelebrationPopup from "../../../components/Popup/GroupCelebration"
import Feed from "./AccountFeed"

interface Props {
  match: Match
}
const Popups = (props: Props) => {
  const {
    params: {type, uuid, view}
  } = props.match
  const recognitionId = type === RECOGNITION ? uuid : null
  const groupCelebrationId = type === GROUP_CELEBRATION ? uuid : null
  return (
    <>
      {recognitionId && (
        <Query query={feedRecognitionQuery.query} variables={{id: recognitionId}} Error={ErrorPopup}>
          {({data: {recognition}}) => <RecognitionPopup recognition={recognition} hasReward={view === REWARD} key={view} redirectToFeed />}
        </Query>
      )}
      {groupCelebrationId && (
        <Query query={groupCelebrationQuery.query} variables={{id: groupCelebrationId}} Error={ErrorPopup}>
          {({data: {groupCelebration}}) => (
            <GroupCelebrationPopup groupCelebration={groupCelebration} hasReward={view === REWARD} key={view} redirectToFeed />
          )}
        </Query>
      )}
    </>
  )
}
const MyRecognitionsFeed = () => {
  useEffect(() => {
    tracking.viewProfile()
  }, [])

  const recognitionsProps = {...accountRecognitionsQuery, variables: accountRecognitionsQuery.variables}
  return (
    <>
      <Card tiny noBorder>
        <DisablePointerEventsOnScroll>
          <Feed recognitions={recognitionsProps} />
        </DisablePointerEventsOnScroll>
      </Card>
      <NestedRoute
        useGrid={false}
        match={"/recognition/account/my-recognition"}
        path={RawRecognitionRoutes.ACCOUNT_RECOGNITIONS}
        title="Celebration"
        component={Popups}
      />
    </>
  )
}

export default MyRecognitionsFeed
